/**
 * Desktop Navigation Component
 * Handles the main navigation bar with spotlight effects
 */
import { NAV_LINKS } from '../../config/brand';
import { navigateToSection } from '../../utils/navigation';
import spotlight from '../../utils/spotlight';

const DesktopNavigation = () => {
  return (
    <div className="border-t-brick-500/30 top-20 container mx-auto my-0 flex hidden h-9 w-full max-w-full min-w-full items-center justify-between border-t border-t-zinc-500/30 bg-zinc-950/75 px-0 py-0 pb-0 backdrop-blur md:inline md:px-4">
      <div className="mx-auto flex h-full w-screen items-center justify-between gap-0 text-sm font-semibold md:w-auto md:max-w-2/3">
        {NAV_LINKS.map(({ href, label }) => (
          <button
            key={href}
            type="button"
            className="btn-hover h-full w-full min-w-30 px-6"
            onClick={() => navigateToSection(href.slice(1))}
            onMouseMove={spotlight}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DesktopNavigation;
